<template>
    <div class="warpper">
        <div class="info-container">
            <div class="page-title">基本信息</div>
            <el-form class="info margin-top" ref="ruleForm" :model="ruleForm" :rules="rules" labelWidth="auto">
                <el-row :gutter="21">
                    <el-col :span="12">
                        <el-form-item ref="invoice_name" label="开票名称" prop="invoice_name" class="input-container">
                            <el-input v-model="ruleForm.invoice_name" placeholder="请输入" :disabled="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item ref="invoice_identifier" label="纳税人识别号" prop="invoice_identifier"
                                      class="input-container">
                            <el-input v-model="ruleForm.invoice_identifier" placeholder="请输入"
                                      :disabled="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="21">
                    <el-col :span="12">
                        <el-form-item ref="invoice_tel" label="联系电话" prop="invoice_tel" class="input-container">
                            <el-input v-model="ruleForm.invoice_tel" placeholder="请输入" :disabled="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item ref="invoice_address" label="收件地址" prop="invoice_address" class="input-container">
                            <el-input v-model="ruleForm.invoice_address" placeholder="请输入"
                                      :disabled="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="flex align-center justify-center">
                    <el-button type="primary" @click="submitForm('ruleForm')" class="input-form-btn"
                               :loading="loading">{{readonly ? '编辑' : '提交'}}
                    </el-button>
                </div>
            </el-form>
        </div>
        <div class="info-container margin-top-sm flex-sub">
            <div class="page-title">缴费信息</div>
            <div class="ship-list flex flex-direction align-center margin-top">
                <el-table
                        v-loading="dloading"
                        :data="tableData"
                        header-row-class-name="table-header"
                        border
                        style="width: 100%;border-radius: 10px">
                    <el-table-column prop="name" label="会员身份">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{scope.row.name}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="pay_amount" label="缴费金额（元）">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{scope.row.pay_amount}}
                            </div>
                        </template>
                    </el-table-column>


                    <el-table-column prop="add_time" label="缴纳日期">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{scope.row.add_time}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="end_time" label="到期日期">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{scope.row.end_time}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="is_fp" label="操作">
                        <template slot-scope="scope">
                            <div class="table-operate">
                                <el-button class="operate" v-if="scope.row.is_fp === 0"
                                           @click="applyInvoice(scope.row.id)" :loading="loading">申请发票
                                </el-button>
                                <el-button class="operate disabled" @click="applyIng()" v-if="scope.row.is_fp === 1">
                                    已申请发票
                                </el-button>
                                <el-link class="operate" :href="scope.row.fapiao_img" :underline="false" target="_blank" v-if="scope.row.is_fp === 2">已开发票</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import rules from '@/utils/rules'
    import {zhDate} from '@/utils/utils'
    import {userInfo, setInvoice, getPayLog,applyInvoice} from '@/api/member'

    export default {
        name: "vipShip",
        components: {},
        data() {
            return {
                readonly: true,
                ruleForm: {
                    invoice_name: '',
                    invoice_identifier: '',
                    invoice_tel: '',
                    invoice_address: '',
                },
                rules: {
                    invoice_name: [
                        {required: true, message: "请输入开票名称", trigger: "blur"},
                    ],
                    invoice_identifier: [
                        {required: true, message: "请输入纳税人识别号", trigger: "blur"}
                    ],
                    invoice_tel: [
                        {required: true, message: "请输入联系电话", trigger: "blur"},
                        rules.phone
                    ],
                    invoice_address: [
                        {required: true, message: "请输入收件地址", trigger: "blur"}
                    ]
                },
                loading: false,
                tableData: [],
                dloading: false,
            }
        },
        created() {
            this.$emit('setIndex', 2, '会费信息')
            this.init()
        },
        methods: {
            async init() {
                let _data = await userInfo()
                if (_data.status === 200) {
                    _data.data.end_time = zhDate(_data.data.end_time * 1000)
                    _data.data.reg_time = zhDate(_data.data.reg_time * 1000)
                    this.ruleForm = {
                        invoice_name: _data.data.invoice_name,
                        invoice_identifier: _data.data.invoice_identifier,
                        invoice_tel: _data.data.invoice_tel,
                        invoice_address: _data.data.invoice_address,
                    }
                }
                this.dloading = true
                let _list = await getPayLog()
                this.dloading = false
                if (_list.status === 200) {
                    _list.data.map(item => {
                        item.add_time = zhDate(item.add_time * 1000)
                        item.end_time = zhDate(item.end_time * 1000)
                    })
                    this.tableData = _list.data
                }
            },
            submitForm(formName) {
                if (this.readonly) return this.readonly = false
                this.$refs[formName].validate((valid, validates) => {
                    if (valid) {
                        this.submitChange();
                    } else {
                        let error = Object.values(validates).shift().shift()
                        let dom = this.$refs[error.field]
                        this.$confirm(error.message, "提示", {
                            confirmButtonText: "确定",
                            showCancelButton: false,
                            type: "warning",
                        }).then(() => {
                            dom.$el.scrollIntoView({
                                block: 'center', // 当前元素显示在视图区域中间
                                behavior: 'auto' // 滚动速度
                            })
                        })
                    }
                });
            },
            async submitChange() {
                this.loading = true
                let _data = await setInvoice(this.ruleForm.invoice_name,
                    this.ruleForm.invoice_identifier, this.ruleForm.invoice_tel, this.ruleForm.invoice_address)
                this.loading = false
                if (_data.status === 200) {
                    this.readonly = false
                    this.$message.success('保存成功')
                }
            },
            async applyInvoice(id){
                this.loading = true
                let _data = await applyInvoice(id)
                this.loading = false
                if (_data.status === 200) {
                    this.init()
                    this.$message.success('申请成功')
                }
            },
            applyIng() {
                this.$confirm('您已申请过发票，若未收到请联系上级', "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    type: "warning",
                }).then(() => {
                })
            }
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        .info-container {
            background-color: #ffffff;
            border-radius: 10px;
            padding: 23px 30px;
            .input-form-btn {
                width: 200px;
                height: 40px;
                line-height: 40px;
                border-radius: 40px;
                font-size: 16px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                color: #ffffff;
                margin-top: 20px;
                padding: 0;
                &.white {
                    background: #ffffff none;
                    color: #ff9600;
                }
                &:disabled {
                    background: #b4c7e5 none;
                }
                &.disabled {
                    background: #b4c7e5 none;
                }
            }
            .table-name {
                font-size: 16px;
                color: #0a2240;
                text-align: center;
            }
            .table-operate {
                text-align: center;
                .operate {
                    width: 110px;
                    height: 36px;
                    line-height: 36px;
                    border-radius: 36px;
                    font-size: 16px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#ff9600, #ff9600);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    padding: 0;
                    &.white {
                        background: #ffffff none;
                        color: #ff9600;
                    }
                    &:disabled {
                        background: #b4c7e5 none;
                    }
                    &.disabled {
                        background: #b4c7e5 none;
                    }
                }
            }

        }
    }
</style>